import { render, staticRenderFns } from "./add-bank-account.component.vue?vue&type=template&id=084dc042&"
import script from "./add-bank-account.component.vue?vue&type=script&lang=ts&"
export * from "./add-bank-account.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports